import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { space, width } from 'styled-system'
import Title from 'elements/Title'
import Label from 'elements/Label'
import Button from 'components/Button'
import { apiBaseURI } from 'utils/api'
import { Google, Wordmark } from 'svg'
import { fadeInRule } from 'utils/animations'
import theme from '../../../../themes/light'

const LogoContainer = styled.div`
  padding-bottom: 5rem;
`

const Wrapper = styled.div`
  max-width: 342px;
  padding-bottom: 5rem;
  animation: ${fadeInRule};
`

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
`

const Terms = styled.p`
  margin-top: auto;
  margin-bottom: auto;
  color: ${theme.colors.gray60};
  font: ${theme.fonts.small};
  text-align: left;

  ${space}
  ${width}
`

class GoogleLogin extends Component {
  UNSAFE_componentWillMount () {
    const {
      signup
    } = this.props
    document.title = signup ? 'Interseller | Signup - Google' : 'Interseller | Login - Google'
  }

  render () {
    const {
      signup,
      discovery
    } = this.props

    const verb = signup ? 'up' : 'in'

    const url = discovery.getIn(['data', 'url']) || `${apiBaseURI}/auth/google/gmail,calendar`
    const redirect = `${window.location.protocol}//${window.location.hostname + (window.location.port ? `:${window.location.port}` : '')}`
    const label = `We've detected that you're using Gmail. Please click the button below to sign ${verb} using Google.`

    return (
      <Wrapper>
        <LogoContainer>
          <Wordmark />
        </LogoContainer>
        <Title>{`Sign ${verb} with Google`}</Title>
        <Label mt='1rem'>{label}</Label>
        <ButtonContainer>
          <Button
            ref={(button) => { this.googleButton = button }}
            full
            bg={theme.colors.white}
            borderColor={theme.labelColor}
            label={`Sign ${verb} with Google`}
            icon={<Google />}
            handleClick={() => {
              if (url.indexOf('?') > -1) {
                window.location = `${url}&redirect=${redirect}`
              } else {
                window.location = `${url}?redirect=${redirect}`
              }
            }}
          />
        </ButtonContainer>
        {signup &&
          <Terms>
            Not using Gmail? You can also sign up with your <a href='/signup/microsoft'>Outlook</a> account.
          </Terms>}
      </Wrapper>
    )
  }
}

GoogleLogin.propTypes = {
  discovery: PropTypes.object,
  signup: PropTypes.bool
}

export default GoogleLogin
